import React, { useContext, useEffect, useState, useMemo } from 'react';
import { isUser } from '../services/userServices';
import CssEditor from './CssEditor';
import AdminLogin from './AdminLogin';
import { UserContext } from '../contexts/UserContext';
import ReCaptcha from './Captcha';
import config from '../config';
import setting from '../setting.json';

export default function IsUser() {
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [showAdmin, SetShowAdmin] = useState(false);

  const { captcha, config: userConfig } = useContext(UserContext) || {};

  // Captcha state'ini takip etmek için
  useEffect(() => {
    console.log("Captcha state değişti:", captcha);
  }, [captcha]);

  // Component yüklendiğinde log
  useEffect(() => {
    console.log("IsUser component yüklendi");
  }, []);

  const isAdminRoute = () => {
    return window.location.pathname.includes("/admin");
  }

  React.useEffect(() => {
    if (isAdminRoute()) {
      setIsAdmin(true);
      SetShowAdmin(true);
    }
  }, []);

  const handleAdminLogin = () => {
    SetShowAdmin(false);
  };

  const handleCloseLogin = () => {
    SetShowAdmin(false);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Captcha kontrolü
    if (!captcha) {
      setError('Lütfen captcha\'yı tamamlayın!');
      if (window.resetCaptcha) {
        window.resetCaptcha();
      }
      return;
    }

    // Captcha token'ını al
    const captchaToken = localStorage.getItem('captcha_token');
    if (!captchaToken) {
      setError('Captcha token bulunamadı. Lütfen tekrar deneyin!');
      if (window.resetCaptcha) {
        window.resetCaptcha();
      }
      return;
    }

    setLoading(true);

    try {
      // API'ye istek at (customConfig parametresi ile)
      const result = await isUser(username, captchaToken, userConfig);

      if (result.status === true) {
        // Context'ten gelen config'i kullan, yoksa fallback
        const targetDomain = userConfig?.domain || config.domain;
        const subdomain = userConfig?.subdomain || '';
        window.location.href = `https://${subdomain}${targetDomain}/${result.user_id}`;
        // Başarılı - yönlendirme yap
      } else {
          // Hata - kullanıcı bulunamadı
          setError(result.message || result.error || 'Kullanıcı bulunamadı veya doğrulanamadı!');
        }
      } catch (err) {
        console.error('API Error:', err);
        setError('Bir hata oluştu. Lütfen tekrar deneyin.');
      } finally {
        setLoading(false);
        // Her durumda captcha'yı resetle
        if (window.resetCaptcha) {
          window.resetCaptcha();
        }
      }
    };

    return (
      <div className="isuser-bg" style={{ background: 'var(--general-bg-gradient, linear-gradient(135deg, #17171A 0%, #2B0A50 100%))' }}>
        <div className="isuser-overlay" />
        <div className="isuser-modal">
          <h2 style={{ color: 'var(--modal-title-color, #f9f6e7)', marginBottom: 12 }}>Hoş Geldiniz</h2>
          <p style={{ color: 'var(--modal-desc-color, #f9f6e7)', marginBottom: 28, fontSize: 'var(--modal-desc-font-size, 17px)' }}>
            Devam etmek için {setting.inputText}
          </p>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder={setting.inputText}
              value={username}
              onChange={e => setUsername(e.target.value)}
              style={{
                width: '100%',
                padding: 'var(--modal-input-padding, 14px)',
                borderRadius: 'var(--modal-input-radius, 10px)',
                border: '2px solid var(--modal-input-border, #232323)',
                background: 'var(--modal-input-bg, #232323)',
                color: 'var(--modal-input-text, #fff)',
                fontSize: 'var(--modal-input-font-size, 16px)',
                marginBottom: '18px',
                cursor: 'pointer',
                boxSizing: 'border-box',
              }}
              required
              disabled={loading}
            />
            {error && <div style={{ color: '#ff4d4f', marginBottom: 12 }}>{error}</div>}
            {!captcha && !loading && (
              <div style={{ color: '#ffa940', marginBottom: 12, fontSize: '14px' }}>
                ⚠️ Lütfen güvenlik doğrulamasını tamamlayın
              </div>
            )}

            <button
              type="submit"
              style={{
                width: '100%',
                padding: '16px',
                borderRadius: '12px',
                border: '2px solid var(--modal-button-border, #c12737)',
                background: 'var(--modal-button-bg, #c12737)',
                color: 'var(--modal-button-text, #fff)',
                fontSize: '18px',
                fontWeight: 500,
                cursor: loading || !captcha ? 'not-allowed' : 'pointer',
                opacity: loading || !captcha ? 0.5 : 1,
                transition: 'all 0.2s',
              }}
              disabled={loading || !captcha}
            >
              {loading ? 'Kontrol Ediliyor...' : 'Devam Et'}
            </button>
          </form>
          <br />

          <ReCaptcha />
        </div>


        <style>{`
        .isuser-bg {
          min-height: 100vh;
          width: 100vw;
          position: fixed;
          top: 0; left: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          z-index: 1000;
        }
        .isuser-overlay {
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background: radial-gradient(circle at 50% 50%, #18181c 70%, #000 100%);
          opacity: 0.92;
          animation: overlayFadeIn 1.2s cubic-bezier(.4,0,.2,1);
          z-index: 1;
        }
        .isuser-bg::before {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background: linear-gradient(120deg, #c12737 0%, #232323 100%);
          opacity: 0.18;
          filter: blur(60px);
          animation: gradientMove 8s linear infinite alternate;
          z-index: 0;
        }
        .isuser-modal {
          position: relative;
          z-index: 2;
          background: var(--modal-bg, rgba(30, 30, 30, 0.97));
          border-radius: 18px;
          box-shadow: 0 4px 32px rgba(0,0,0,0.7);
          padding: 40px 32px;
          min-width: 350px;
          max-width: 90vw;
          text-align: center;
          opacity: 0;
          transform: translateY(40px) scale(0.98);
          animation: modalFadeIn 1.1s cubic-bezier(.4,0,.2,1) 0.2s forwards;
          border: 2px solid var(--modal-border, #c12737);
          color: var(--modal-text, #f9f6e7);
        }
        .isuser-modal h2, .isuser-modal p {
          color: var(--modal-text, #f9f6e7);
        }
        .isuser-modal button {
          background: var(--modal-button-bg, #c12737);
          color: var(--modal-button-text, #fff);
          border: 2px solid var(--modal-button-border, #c12737);
        }
        @keyframes overlayFadeIn {
          from { opacity: 0; }
          to { opacity: 0.92; }
        }
        @keyframes modalFadeIn {
          from { opacity: 0; transform: translateY(40px) scale(0.98); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes gradientMove {
          0% { background-position: 0% 50%; }
          100% { background-position: 100% 50%; }
        }
      `}</style>


        {isAdmin && showAdmin && (
          <AdminLogin onLogin={handleAdminLogin} onClose={handleCloseLogin} />
        )}

        {isAdmin && !showAdmin && (
          <CssEditor />
        )}
      </div>
    );
  }
